import $ from 'jquery';
import {updateLoginBoxNamesLhs} from '../commons/loginbox/name';
import {MARKET} from 'Utils/market.constants';

const initLastConnectionMessage = function () {

    const COOKIE_LAST_CONNECTION = "lastDate";
    const COOKIE_LAST_MEDIA = "lastMedia";
    //const MESSAGE_DURATION = 5000;

    // Cookie functions
    function getCookie(name) {
        var value = "; " + document.cookie;
        var parts = value.split("; " + name + "=");
        if (parts.length == 2)
            return parts.pop().split(";").shift();
        return "";
    }
    function deleteCookie(name) { document.cookie = `sg-website-assets=;path=/;expires=Thu, 01 Jan 1970 00:00:01 GMT;`; }

	// Load cookies 
    var cookieLastConnection = getCookie(COOKIE_LAST_CONNECTION);
    var cookieLastMedia = getCookie(COOKIE_LAST_MEDIA);

	// Show banner (if cookie && bannercomponent on page)
    $("#lastConnectionMessage").attr("aria-hidden","true");
    if (cookieLastConnection && cookieLastConnection.length >= 12) {

		// Banner management
        if ($("#lastConnectionBanner").length > 0) {
			
			// Message
			var message = `Dernière connexion `;
			
			// - Date
			var year = cookieLastConnection.substring(0, 4);
			var month = cookieLastConnection.substring(4, 6);
			var day = cookieLastConnection.substring(6, 8);
			var hour = cookieLastConnection.substring(8, 10);
			var minute = cookieLastConnection.substring(10, 12);
			var lastConnection = `${day}/${month}/${year} à ${hour}h${minute}` ;

			// - Média
			var media;
			switch(cookieLastMedia) {
				case 'WAP' : media = 'sur Services Mobiles';
					break;
				case 'VOC' : media = 'au 3933';
					break;
				default :    media = 'par Internet';
			}
			message = message + `${media} le ${lastConnection}`;
			
			// - Client name
			var clientName = updateLoginBoxNamesLhs();
			if (MARKET.CODE === 1) message = `Bonjour ${clientName} ! ` + message + `.`;

			$("#lastConnectionMessage").text(message);
			$("#lastConnectionMessage").attr("aria-hidden","false");

            $("#lastConnectionBanner").show();		
            
			// Delete cookie once shown not to display it again during the session
			// Auto hide after 5 seconds : setTimeout(function () { $("#lastConnectionBanner").hide(); }, MESSAGE_DURATION);
            deleteCookie(COOKIE_LAST_CONNECTION);
				
			// Button close click event : Hide the messagebanner 
			$('#lastConnectionBanner div button').on('click', function(e) {
				e.preventDefault();
				$("#lastConnectionBanner").hide();
			});
        }
    }

};

export {initLastConnectionMessage};


// WEBPACK FOOTER //
// ./src/js/cms/commons/last-connection-message.js